import { render, staticRenderFns } from "./TopicSelect.vue?vue&type=template&id=a7c2e406&"
import script from "./TopicSelect.ts?vue&type=script&lang=ts&"
export * from "./TopicSelect.ts?vue&type=script&lang=ts&"
import style0 from "./TopicSelect.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports